var components = {'uPicker': require('@/uni_modules/uview-ui/components/u-picker/u-picker.vue').default}
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('u-picker',{ref:"picker",attrs:{"show":_vm.show,"closeOnClickOverlay":_vm.closeOnClickOverlay,"columns":_vm.columns,"title":_vm.title,"itemHeight":_vm.itemHeight,"showToolbar":_vm.showToolbar,"visibleItemCount":_vm.visibleItemCount,"defaultIndex":_vm.innerDefaultIndex,"cancelText":_vm.cancelText,"confirmText":_vm.confirmText,"cancelColor":_vm.cancelColor,"confirmColor":_vm.confirmColor},on:{"close":function($event){
arguments[0] = $event = _vm.$handleEvent($event);
(_vm.close).apply(void 0, arguments)
},"cancel":function($event){
arguments[0] = $event = _vm.$handleEvent($event);
(_vm.cancel).apply(void 0, arguments)
},"confirm":function($event){
arguments[0] = $event = _vm.$handleEvent($event);
(_vm.confirm).apply(void 0, arguments)
},"change":function($event){
arguments[0] = $event = _vm.$handleEvent($event);
(_vm.change).apply(void 0, arguments)
}}})}
var recyclableRender = false
var staticRenderFns = []

export { render, staticRenderFns, recyclableRender, components }